<template>
    <transition name="vue-table-loader">
        <div class="vue-table-loader" v-if="show">
            <div class="hourglass-container">
                <div class="hourglass" :style="styles">
                    <div class="top"></div>
                    <div class="bottom"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "hourglass-loader",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        time: {
            type: String,
            default: '5s',
        }
    },
    computed: {
        styles() {
            return {
                '--time': this.time,
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.vue-table-loader {
    font-size: 4em;
}
.hourglass-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .hourglass {
        animation: flip var(--time) ease-in-out infinite;
        border-bottom: solid 0.05em #333;
        border-top: solid 0.05em #333;
        padding: 0 0.05em;
        position: relative;
        font-size: 1em;
        .top, .bottom {
            background-color: #def;
            box-shadow: 0 0 0.05em 0.05em #bcd inset;
            height: 0.455em;
            overflow: hidden;
            position: relative;
            width: 0.455em;
        }
        .top {
            border-radius:0 0 50% 50%;
            &:before {
                animation: top var(--time) linear infinite;
                background-color: #00b0d8;
                border-radius: 50%;
                content: "";
                display: block;
                height: 0.45em;
                left: 0;
                position: absolute;
                top: 0;
                transform: translateY(50%);
                width: 0.45em;
            }
            &:after {
                animation: top-drip var(--time) linear infinite;
                background-color: #00b0d8;
                content: "";
                display: block;
                height: 100%;
                left: 45%;
                position: absolute;
                top: 0;
                transform: translateY(100%);
                width: 10%;
            }
        }
        .bottom {
            border-radius:50% 50% 0 0;
            &:before {
                animation: bottom var(--time) linear infinite;
                background-color: #00b0d8;
                border-radius: 50%;
                content: "";
                display: block;
                height: 0.45em;
                left: 0;
                position: absolute;
                top: 0;
                transform: translateY(100%);
                width: 0.45em;
            }
            &:after {
                animation: bottom-drip var(--time) linear infinite;
                background-color: #00b0d8;
                content: "";
                display: block;
                height: 100%;
                left: 45%;
                position: absolute;
                top: 0;
                width: 10%;
            }
        }
    }
}


@keyframes flip {
    0%, 45% {
        transform: rotate(0);
    }
    50%, 95% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes bottom {
    0% {
        transform: translateY(100%);
    }
    50% {
        transform: translateY(50%);
    }
    51% {
        transform: translateY(-50%);
    }
    100% {
        transform: translateY(-100%);
    }
}

@keyframes top {
    0% {
        transform: translateY(50%);
    }
    50% {
        transform: translateY(100%);
    }
    51% {
        transform: translateY(-100%);
    }
    100% {
        transform: translateY(-50%);
    }
}

@keyframes bottom-drip {
    0% {
        left: 45%;
        transform: translateY(-100%);
        width: 10%;
    }
    5% {
        transform: translateY(0);
    }
    45%, 100% {
        left: 50%;
        transform: translateY(0);
        width: 0;
    }
}

@keyframes top-drip {
    0%, 50% {
        left: 45%;
        transform: translateY(100%);
        width: 10%;
    }
    55% {
        left: 45%;
        transform: translateY(0);
        width: 10%;
    }
    100% {
        left: 50%;
        transform: translateY(0);
        width: 0;
    }
}
</style>
